import { Activity } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import { cn } from '../../@/lib/utils'
import { DossSignalType, useDossSignals } from '../../common/hooks/useDossSignals'

export function ActivityFeedButton() {
  const { dispatch, subscribe, unsubscribe } = useDossSignals()
  const [showButton, setShowButton] = useState(true)
  const { t } = useTypedTranslation()
  const handleClick = async () => {
    await dispatch(DossSignalType.EXPAND_ACTIVITY_FEED_CLICKED)
  }

  useEffect(() => {
    const openId = subscribe(DossSignalType.ACTIVITY_FEED_EXPANDED, async () => {
      setShowButton(false)
    })
    const closeId = subscribe(DossSignalType.ACTIVITY_FEED_COLLAPSED, async () => {
      setShowButton(true)
    })

    return () => {
      unsubscribe(openId)
      unsubscribe(closeId)
    }
  }, [subscribe, unsubscribe])

  return (
    <div
      className={cn(
        'text-gray-10 flex rounded hover:bg-gray-2 font-normal gap-2 px-2.5 py-2 items-center justify-center cursor-pointer transition-opacity duration-300',
        showButton ? 'opacity-100' : 'opacity-0 pointer-events-none',
      )}
      onClick={handleClick}
    >
      <Activity className="size-3" />
      {t('navigation.activity')}
    </div>
  )
}
